import { FieldAddonDropdown } from '@dixa/lib-shared-habla';
import { FieldInputText } from 'lib-knowledge-form';
import { LanguageModel } from 'lib-knowledge-management-common/hooks/useManagementLanguages';
import { Control, Controller, UseFormWatch } from 'react-hook-form';

import { ArticleAddModalSchema } from './articleAddModalSchema';

type TitleInputProps = {
  watch: UseFormWatch<ArticleAddModalSchema>;
  control: Control<ArticleAddModalSchema>;
  enabledLanguages: Array<LanguageModel>;
  required?: boolean;
};

export const TitleInput = ({
  watch,
  enabledLanguages,
  control,
  required,
}: TitleInputProps): JSX.Element => {
  const selectedLang = watch('language');

  const dropdownListItems = enabledLanguages.map((l) => ({
    id: l.languageId,
    name: l.description,
  }));

  return (
    <FieldInputText
      control={control}
      name="articleTitle"
      required={required}
      label="Name"
      prefix={{
        type: 'custom',
        noWrap: true,
        value: (
          <Controller
            control={control}
            name="language"
            render={({ field }) => {
              return (
                <FieldAddonDropdown
                  meta={{
                    selectedValue: <span>{selectedLang.name}</span>,
                  }}
                  items={dropdownListItems}
                  onSelect={(item) => field.onChange(item)}
                />
              );
            }}
          />
        ),
      }}
    />
  );
};
